// ensures that the prefix is correct
var Prefix;
(function (Prefix) {
    Prefix["Label"] = "label";
    Prefix["HelperText"] = "help";
})(Prefix || (Prefix = {}));
var ValidationAdornmentPlacement;
(function (ValidationAdornmentPlacement) {
    ValidationAdornmentPlacement["Input"] = "input";
    ValidationAdornmentPlacement["HelperText"] = "helper";
})(ValidationAdornmentPlacement || (ValidationAdornmentPlacement = {}));
/**
 * replaces all white spaces with hyphens and converts to lowercase
 * @param string ie: 'I    \r        \n      am a      \t STRING'
 * @returns lowercase string with no spaces ie: 'i-am-a-string'
 */
var convertToSlug = function (string) { return string.replace(/\s+/g, '-').toLowerCase(); };
/**
 * removes all non-alphanumeric characters except hyphens
 * @param string ie: 'I am a string!!!_@'
 * @returns lowercase string with no spaces ie: 'Iamastring'
 */
var removeNonAlphaNumericHyphen = function (string) { return string.replace(/[^a-zA-Z0-9-]/g, ''); };
/**
 *  Certain strings, like HTML attribute 'id', must start with a letter.
 * This function ensures that the string doesn't start with an invalid char.
 * If a prefix is provided, it will be prepended to the string.
 * @param string "123abc"
 * @param prefix "prefix" must start with a letter, not a number
 * @returns sanitized string with prefix ie: "prefix-123abc" or "abc" if no prefix
 */
var ensureStringStartsWithValidPrefix = function (string, prefix) {
    var sanitized = string.replace(/^[^a-zA-Z]+/, '');
    return prefix ? "".concat(prefix.toString(), "-").concat(sanitized) : sanitized;
};
/**
 * removes all non-alphabetic characters from beginning
 * and non-alphanumeric from end of string
 * @param string ie: '123id-'
 * @returns string ie: 'id'
 */
var trimNonAlphanumericChars = function (string) {
    return string.replace(/^[^a-zA-Z]+|[^a-zA-Z0-9]+$/g, '');
};
/**
 * The id cannot start with a number,
 * must not contain whitespaces (spaces, tabs, etc.)
 * and must not contain any non-alphanumeric characters except hyphens.
 * @param string String to be converted to valid id. ie: 'Address 2'
 * @param prefix Optional parameter to prepend to the string. ie: 'label'
 * @returns string. ie: 'label-address-2'
 */
var toValidId = function (string, prefix) {
    var slug = convertToSlug(string);
    var removeInvalidChars = removeNonAlphaNumericHyphen(slug);
    var prefixAdded = ensureStringStartsWithValidPrefix(removeInvalidChars, prefix);
    var sanitized = trimNonAlphanumericChars(prefixAdded);
    return sanitized;
};
/**
 *
 * @param string[] Array of possible variant strings
 * @returns getIsSupportedVariant() function with correct variants and typesafety
 */
function createIsSupportedVariant(variants) {
    return function (variant) {
        return variants.includes(variant);
    };
}

export { Prefix, ValidationAdornmentPlacement, createIsSupportedVariant, toValidId };
//# sourceMappingURL=utils.js.map
